import { Button } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { FileWithPath, useDropzone } from 'react-dropzone'

import { getTranslate } from '../../localization'
import { ImagePropsForDropZone } from '../../types/image'
import useStyles from './styles/index.styles'

interface UploadSingleFileProps {
  image: ImagePropsForDropZone | undefined
  setImage: (v: ImagePropsForDropZone) => void
  sitekeyId: string
}

const UploadSingleFile = ({
  image,
  setImage,
  sitekeyId
}: UploadSingleFileProps) => {
  const [hasURL, setHasURL] = useState<boolean>(false)

  useEffect(() => {
    if (image?.fileURL) {
      setHasURL(true)
    } else {
      setHasURL(false)
    }
  }, [image])

  const classes = useStyles()

  const onDrop = (acceptedFiles: FileWithPath[]) => {
    setImage({
      file: acceptedFiles[0],
      fileURL: URL.createObjectURL(acceptedFiles[0]),
      entityID: sitekeyId,
      entityCode: '',
      entityType: 'WBSSite',
      imageType: 'Image'
    })
  }
  const { getRootProps, getInputProps } = useDropzone({
    onDrop
  })

  const ImageContainerSwitch = () => {
    if (hasURL) {
      return (
        <div className={classes.root} {...getRootProps()}>
          <img className={classes.image} src={image?.fileURL} alt="" />
          <Button
            variant="text"
            color="primary"
            className={classes.imageButton}>
            <input {...getInputProps()} />
            {getTranslate('Edit')}
          </Button>
        </div>
      )
    } else if (!hasURL) {
      return (
        <div className={classes.root} {...getRootProps()}>
          <Button
            variant="text"
            color="primary"
            className={classes.imageButton}>
            <input {...getInputProps()} />
            {getTranslate('Upload')}
          </Button>
        </div>
      )
    }
  }

  return <div className={classes.imageContainer}>{ImageContainerSwitch()}</div>
}
export default UploadSingleFile
